import TTag from './tag.vue'

TTag.install = Vue => {
  Vue.component(TTag.name, TTag)
}

export default TTag



// WEBPACK FOOTER //
// ./src/module/tag/index.js